import { favoritesApi as api } from './favoritesApi';
export const addTagTypes = ['Favorites'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      addFavorites: build.mutation<AddFavoritesApiResponse, AddFavoritesApiArg>(
        {
          query: queryArg => ({
            url: `/favorites`,
            method: 'POST',
            body: queryArg.createFavorites
          }),
          invalidatesTags: ['Favorites']
        }
      )
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type AddFavoritesApiResponse =
  /** status 201 Favorites has been created successfully. */ {
    ok?: boolean;
    data?: Favorites;
    message?: string;
  };
export type AddFavoritesApiArg = {
  /** Favorites that needs to be added to the application */
  createFavorites: CreateFavorites;
};
export type Favorites = {
  count?: number;
  rows?: {
    id?: string;
    status?: string;
    subscriberId?: string;
    assetId?: string;
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
  }[];
};
export type CreateFavorites = {
  subscriberId: string;
  userId: string;
  assetId: string;
  status: string;
  createdBy?: string;
};
export const { useAddFavoritesMutation } = injectedRtkApi;
